import * as AdminApi from './admin-api'

export { AdminApi }
